/* istanbul ignore file */
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
import { Currency } from './Currency';
import { TaxBehavior } from './TaxBehavior';
const PutTenantWidePriceTenantDataParser = 
/* #__PURE__ */ parsers.object([
    ['currency', Currency],
    ['amount', parsers.decimal],
    ['refundPeriod', parsers.duration, 'refund_period'],
    ['taxBehavior', TaxBehavior, 'tax_behavior'],
]);
export class PutTenantWidePriceTenantData extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return PutTenantWidePriceTenantDataParser.decode(input).map(res => new PutTenantWidePriceTenantData(res));
    }
    static unsafeDecode(input) {
        return PutTenantWidePriceTenantData.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return PutTenantWidePriceTenantDataParser.encode(data);
    }
    static schema() {
        return PutTenantWidePriceTenantDataParser.schema();
    }
}
